function rethrowNativeError(error) {
  if (error instanceof Error) {
    var message = error.message.trimEnd();
    var coded = /(?:^|:\s)((?:E|ERR)_[A-Z0-9_]+): ([\s\S]*)$/.exec(message);
    error.message = coded ? coded[2] : message;
    if (coded) Object.assign(error, {
      code: coded[1]
    });
  }
  throw error;
}
function missingNativeBuild(operation) {
  return new Error(`${operation} needs an iOS or Android build`);
}
export {
  missingNativeBuild,
  rethrowNativeError
};
//# sourceMappingURL=nativeError.js.map
